module.exports = __webpack_public_path__ + "img/header-engagementRingsDiamonds@2x.b5d3b68.webp";